export const INTEGRATION_REQUIREMENTS = {
	FINAGO_TIME: {
		tokenKey: 'credentialsFinagoTime',
		label: 'FinagoTime',
		validateOnDraftSave: false,
		fields: [
			{ path: 'forename', label: 'Forename' },
			{ path: 'surname', label: 'Surname' },
			{ path: 'socSec', label: 'SocSec' },
			{ path: 'otherDetails.email', label: 'EmailWork' },
			{ path: 'employmentDetails.startDate', label: 'StartDate' },

			{ path: 'salaryDetails.formOfSalary', label: 'FormOfSalary' },
			{ path: 'employmentDetails.fixedDuration', label: 'FixedDuration' },
			{ path: 'employmentDetails.cbaCode', label: 'CbaCode' },
			{ path: 'employmentDetails.profession', label: 'Profession' },
			{ path: 'controlDetails.payGroup', label: 'PayGroup' },
			{ path: 'controlDetails.teams', label: 'Teams' },
		],
	},
	VELHO: {
		tokenKey: 'credentialsVelho',
		label: 'Velho',
		fields: [
			{ path: 'forename', label: 'Forename' },
			{ path: 'surname', label: 'Surname' },
			{ path: 'nr', label: 'Nr' },
			{ path: 'controlDetails.payGroup', label: 'PayGroup' },
			{ path: 'controlDetails.teamMemberships', label: 'Teams' },
			{ path: 'employmentDetails.startDate', label: 'StartDate' },
			{ path: 'employmentDetails.cbaCode', label: 'CbaCode' },
			{ path: 'employmentDetails.profession', label: 'Profession' },
			{ path: 'salaryDetails.formOfSalary', label: 'FormOfSalary' },
		],
	},
	PROCOUNTOR: {
		tokenKey: 'tokenProcountor',
		label: 'Procountor',
		fields: [
			{ path: 'forename', label: 'Forename' },
			{ path: 'surname', label: 'Surname' },
			{ path: 'socSec', label: 'SocSec' },
			{ path: 'details.iban', label: 'IBAN' },
		],
	},
}

const getValueByPath = (obj, path) => {
	return path.split('.').reduce((acc, part) => acc?.[part], obj)
}

const getIntegrationFieldValue = (person, path) => {
	const value = getValueByPath(person, path)

	if (path === 'controlDetails.teams') {
		const hasNoTeams = value == null || (Array.isArray(value) && value.length === 0)
		if (hasNoTeams) {
			return getValueByPath(person, 'controlDetails.teamMemberships')
		}
	}

	return value
}

export const validateActiveIntegrations = (person, activeIntegrations, phase = 'activation') => {
	const errors = []

	Object.keys(INTEGRATION_REQUIREMENTS).forEach((key) => {
		const config = INTEGRATION_REQUIREMENTS[key]
		if (phase === 'draftSave' && config.validateOnDraftSave === false) {
			return
		}
		if (activeIntegrations[config.tokenKey]) {
			const missingFields = config.fields
				.filter((field) => {
					const value = getIntegrationFieldValue(person, field.path)

					if (Array.isArray(value)) {
						return value.length === 0
					}

					if (typeof value === 'boolean') return false
					return value === null || value === undefined || value.toString().trim() === ''
				})
				.map((field) => ({
					path: field.path,
					label: field.label,
				}))

			if (missingFields.length > 0) {
				errors.push({
					name: config.label,
					missingFields: missingFields,
				})
			}
		}
	})
	return errors
}
